import React, { useState, useEffect } from 'react'
import { Panel, Row } from 'rsuite'
import { useHistory } from 'react-router-dom'
import SubprojectTable from './SubprojectTable'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'

export default function SubProjectListWidget({ schema }) {
  const history = useHistory()

  return (
    <Panel
      header={`${schema?.header} - ${schema?.projectInfo?.projectName}`}
      shaded
      collapsible
      bordered
      defaultExpanded
    >
      <MiniProjectInfo schema={schema?.projectInfo} />

      <SubprojectTable datas={schema?.subProjectList} />
    </Panel>
  )
}
